
/* injects from baggage-loader */

'use strict';

import AccountDocumentRequestReviewComponent from './account.document-request-review.component';

const AccountDocumentRequestReviewPageModule = angular.module('account-document-request-review-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.document-request-review', {
        data: {
          title: 'Review Document Request',
          navTitle: 'Review Document Request'
        },
        url: '/document-requests/{id}?action',
        component: 'accountDocumentRequestReview',
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          documentRequest: function($transition$, Product, ProductDocument, DocumentRequest, ) {
            return DocumentRequest.get($transition$.params('to').id);
          }
        }
      });
  })
  .component('accountDocumentRequestReview', new AccountDocumentRequestReviewComponent());

export default AccountDocumentRequestReviewPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/document-request-review/account.document-request-review.module.js